import { Component } from 'react';

import classNames from 'classnames';

import { getDecimalSymbol } from '../../../helpers/currency';
import { FormattedCurrency } from '../../../iwIntlProvider/FormattedCurrency';

export class MoneyWithDecimals extends Component<{
    className?: string;
    integerWithSymbolClassName?: string;
    decimalWithSeparatorClassName?: string;
    value?: number;
}> {
    getStyleClass() {
        const { className } = this.props;

        return classNames(className, 'moneyWithDecimalClass');
    }

    renderSeparatedAmount = (formattedAmount: string) => {
        const { integerWithSymbolClassName, decimalWithSeparatorClassName } =
            this.props;

        const decimalDeliminator = getDecimalSymbol();
        return (
            <>
                <span className={integerWithSymbolClassName}>
                    {formattedAmount.split(decimalDeliminator)[0]}
                </span>
                <span className={decimalWithSeparatorClassName}>
                    {`${decimalDeliminator}${
                        formattedAmount.split(decimalDeliminator)[1]
                    }`}
                </span>
            </>
        );
    };

    render() {
        const { value } = this.props;
        const separatedAmount = this.renderSeparatedAmount;
        const moneyWithDecimalClass = this.getStyleClass();

        return (
            <FormattedCurrency
                decimalPlaces={2}
                value={value!}
                modifiedAmount={separatedAmount}
                className={moneyWithDecimalClass}
            />
        );
    }
}
